
import clsx from "clsx";

export type SpinnerSize = "sm" | "md" | "lg";

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: "spinner-sm",
  md: "",
  lg: "spinner-lg",
};

export function Spinner({ size = "md", className }: SpinnerProps) {
  return <div className={clsx("spinner", sizeClasses[size], className)} />;
}

export default Spinner;
